import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn.js';

import './controls.css';

// The page title (h1): Bricolage 700, 30/40 on desktop and 26/34 on phone —
// the same on every screen. Colour and layout (flex, margins) are the caller's.

export const PageTitle = ({
  className,
  ...rest
}: HTMLAttributes<HTMLHeadingElement>): ReactElement => (
  <h1 className={cn('nu-h1', className)} {...rest} />
);
